import get from 'lodash/get'
import isEqual from 'lodash/isEqual'
import { constants } from 'gipsy-misc'

export const areWeeklyWorkingHoursRepeated = weeklyWorkingHours => {
  if (!weeklyWorkingHours || !Object.keys(weeklyWorkingHours).length) {
    return false
  }
  let workStart, workEnd
  for (let day in weeklyWorkingHours) {
    if (!weeklyWorkingHours[day].active) {
      continue
    }
    /* assign the first active day on the list for reference */
    if (!workStart || !workEnd) {
      workStart = get(weeklyWorkingHours, `${day}.workStart`)
      workEnd = get(weeklyWorkingHours, `${day}.workEnd`)
    }

    /* deep comparison between reference and current day workStart */
    const dayWorkStart = get(weeklyWorkingHours, `${day}.workStart`)
    if (workStart && dayWorkStart && !isEqual(workStart, dayWorkStart)) {
      return false
    }

    /* deep comparison between reference and current day workEnd */
    const dayWorkEnd = get(weeklyWorkingHours, `${day}.workEnd`)
    if (workEnd && dayWorkEnd && !isEqual(workEnd, dayWorkEnd)) {
      return false
    }
  }

  return true
}

export const getFirstActiveDayWorkingHours = weeklyWorkingHours => {
  let workStart = constants.defaultWorkStart
  let workEnd = constants.defaultWorkEnd

  if (!weeklyWorkingHours) {
    return { workStart, workEnd }
  }
  for (let day of constants.weekdays) {
    if (
      get(weeklyWorkingHours, `${day}.active`) &&
      typeof get(weeklyWorkingHours, `${day}.workStart.hour`) !== 'undefined' &&
      typeof get(weeklyWorkingHours, `${day}.workStart.minute`) !== 'undefined' &&
      typeof get(weeklyWorkingHours, `${day}.workEnd.hour`) !== 'undefined' &&
      typeof get(weeklyWorkingHours, `${day}.workEnd.minute`) !== 'undefined'
    ) {
      workStart = { hour: weeklyWorkingHours[day].workStart.hour, minute: weeklyWorkingHours[day].workStart.minute }
      workEnd = { hour: weeklyWorkingHours[day].workEnd.hour, minute: weeklyWorkingHours[day].workEnd.minute }

      return { workStart, workEnd }
    }
  }
  return { workStart, workEnd }
}

/* if we only have one active day */
export const hasOnlyOneActiveDay = weeklyWorkingHours => {
  let active = 0
  for (let day in weeklyWorkingHours) {
    if (weeklyWorkingHours[day].active) {
      active++
    }
  }

  return active === 1
}



// WEBPACK FOOTER //
// ./src/pages/settings/components/workinghours/utils.js